const INR = new Intl.NumberFormat('en-IN', { maximumFractionDigits: 0 });
const INR2 = new Intl.NumberFormat('en-IN', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/** Whole-rupee display with the ₹ sign and Indian grouping — 45000 → "₹450". */
export const formatRupees = (paise: number): string => `₹${INR.format(Math.round(paise / 100))}`;

/** Exact 2-decimal display for money breakdowns — 72 → "₹0.72", 2472 → "₹24.72". */
export const formatRupeesExact = (paise: number): string => `₹${INR2.format(paise / 100)}`;

/** Compact rupee display for large sums — 421847 → "₹4.2K", 1_800_00 → "₹1.8L". */
export const formatRupeesCompact = (paise: number): string => {
  const rupees = Math.round(paise / 100);
  if (rupees >= 100_000) return `₹${(rupees / 100_000).toFixed(1)}L`;
  if (rupees >= 1_000) return `₹${(rupees / 1_000).toFixed(1)}K`;
  return `₹${INR.format(rupees)}`;
};
